/**
 * Join truthy class-name parts into a single space-separated `className`
 * string. Shared by the `components/ui` primitives so the
 * `[…].filter(Boolean).join(' ')` idiom lives in one place instead of being
 * re-inlined per component (UID-229 review #3).
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ')
}
